var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("van-field", {
        attrs: {
          rows: "3",
          autosize: "",
          label: "ticket",
          type: "textarea",
          maxlength: "540",
          placeholder: "ticket",
          "show-word-limit": "",
        },
        model: {
          value: _vm.myTicket,
          callback: function ($$v) {
            _vm.myTicket = $$v
          },
          expression: "myTicket",
        },
      }),
      _c("van-field", {
        attrs: {
          rows: "3",
          autosize: "",
          label: "第一个文件地址",
          type: "textarea",
          maxlength: "540",
          placeholder: "请输入第一个文件的地址",
          "show-word-limit": "",
        },
        model: {
          value: _vm.fileUrl_1,
          callback: function ($$v) {
            _vm.fileUrl_1 = $$v
          },
          expression: "fileUrl_1",
        },
      }),
      _c("van-field", {
        attrs: { label: "第一个大小", placeholder: "请输入第一个文件的大小" },
        model: {
          value: _vm.fileSize_1,
          callback: function ($$v) {
            _vm.fileSize_1 = $$v
          },
          expression: "fileSize_1",
        },
      }),
      _c(
        "van-button",
        {
          attrs: { size: "small", plain: "", type: "primary" },
          on: { click: _vm.viewFile_1 },
        },
        [_vm._v(" 查看第一个文件 ")]
      ),
      _c("van-divider"),
      _c("van-field", {
        attrs: {
          rows: "3",
          autosize: "",
          label: "第二个文件地址",
          type: "textarea",
          maxlength: "540",
          placeholder: "请输入第二个文件的地址",
          "show-word-limit": "",
        },
        model: {
          value: _vm.fileUrl_2,
          callback: function ($$v) {
            _vm.fileUrl_2 = $$v
          },
          expression: "fileUrl_2",
        },
      }),
      _c("van-field", {
        attrs: { label: "第一个大小", placeholder: "请输入第二个文件的大小" },
        model: {
          value: _vm.fileSize_2,
          callback: function ($$v) {
            _vm.fileSize_2 = $$v
          },
          expression: "fileSize_2",
        },
      }),
      _c(
        "van-button",
        {
          attrs: { size: "small", plain: "", type: "primary" },
          on: { click: _vm.viewFile_2 },
        },
        [_vm._v(" 查看第二个文件 ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }